import PropTypes from 'prop-types';

import Flux from '../../flux/Flux';
import { postType, postCommentType } from './FeedHelper';
import FeedTipping from './FeedTipping';
import { VXPay } from '../../utils/VXPay';
import { getCurrencyIcon } from '../../utils/CommonUtils.js';
import { Component, Fragment } from 'react';

class FeedPostStats extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showTipping: false,
			isFirst: false,
		};

		this.likeRef;

		this.toggleLike = this.toggleLike.bind(this);
		this.toggleTipping = this.toggleTipping.bind(this);
		this.setShowTipping = this.setShowTipping.bind(this);
		this.onCommentClick = this.onCommentClick.bind(this);
	}

	componentDidMount() {
		Flux.Feed.addLikeChangeListener(this.toggleLike);
	}

	componentWillUnmount() {
		Flux.Feed.removeLikeChangeListener(this.toggleLike);
	}

	onCommentClick() {
		const isTablet = Flux.Browser.isTablet() && Flux.Browser.isPortrait();

		if (this.props.isMobile || isTablet) {
			Flux.Feed.toggleOverlay(this.props.id, Flux.Constants.Feed.OverlayTypes.COMMENTS);
		} else {
			Flux.Feed.toggleOverlay(this.props.id, Flux.Constants.Feed.OverlayTypes.ALL);
		}
	}

	toggleLike(id) {
		if (id !== this.props.id) {
			return;
		}
		if (this.likeRef) {
			this.likeRef.classList.add('feed-footer__stats-item--animation');
			setTimeout(() => {
				this.likeRef.classList.remove('feed-footer__stats-item--animation');
			}, 500);
		}
	}

	getLike() {
		const onClickAction =
			Flux.Guest.isLoggedIn() && this.props.canLike
				? () => Flux.Feed.toggleLike(this.props.id)
				: (Flux.Guest.isLoggedIn()
					? null
					: () => VXPay.openSignupOrLogin());
		return (
			<button className="feed-footer__stats-item" ref={(ref) => (this.likeRef = ref)} onClick={onClickAction}>
				<i className={'h-cursor-pointer icon ' + (this.props.hasLiked ? '-icon-like-full' : '-icon-like-line')} /> {this.props.likes}
			</button>
		);
	}

	getComent() {
		const totalCount = this.props.comments.totalCount;
		return (
			<button
				className="feed-footer__stats-item h-cursor-pointer"
				onClick={Flux.Guest.isLoggedIn() ? this.onCommentClick : () => VXPay.openSignupOrLogin()}
			>
				<i className={'icon ' + (this.props.guestComment ? '-icon-chat-flat' : '-icon-chat-flat-line')} /> {totalCount}
			</button>
		);
	}

	toggleTipping() {
		this.setState({ showTipping: !this.state.showTipping, isFirst: true });
	}

	setShowTipping(show) {
		this.setState({ showTipping: show, isFirst: true });
	}

	getStats() {
		return (
			<Fragment>
				<div className="feed-footer__stats">
					<div className="feed-footer__stats-group">
						{this.getLike()}
						{!this.props.onlyLike && this.getComent()}
					</div>
					{Flux.Guest.isLoggedIn() &&
						!this.props.isRecommended &&
						!this.props.onlyLike &&
						this.props.canLike &&
						(!this.props.tippingGoal || this.props.tippingGoal.achieved) && (
							<button
								onClick={this.toggleTipping}
								className={
									'feed__tip-icon  feed__tip-item-group h-cursor-pointer h-unset-all' +
									(this.state.showTipping ? ' feed__tip-icon--red' : '')
								}
							>
								<i className={'icon ' + getCurrencyIcon()}></i>&nbsp;<span>Tip</span>
							</button>
						)}
				</div>
				<div
					className={
						'feed-footer__stats feed-footer__stats--slide ' +
						(this.state.isFirst ? (this.state.showTipping ? 'feed-footer__stats--slide--show ' : 'feed-footer__stats--slide--hide') : '')
					}
				>
					{
						<FeedTipping
							showTipping={this.state.showTipping}
							setShowTipping={this.setShowTipping}
							model={this.props.model}
							isMobile={this.props.isMobile}
							postId={this.props.id}
							isTippingGoal={this.props.tippingGoal}
						/>
					}
				</div>
			</Fragment>
		);
	}

	render() {
		return this.getStats();
	}
}

FeedPostStats.propTypes = {
	isMobile: PropTypes.bool,
	hasLiked: PropTypes.bool,
	isRecommended: PropTypes.bool,
	comments: PropTypes.shape(postCommentType),
	onlyLike: PropTypes.bool,
	canLike: PropTypes.bool,
	guestComment: PropTypes.object,
	...postType,
};

FeedPostStats.defaultProps = {
	likes: 0,
	comments: [],
	isMobile: false,
	isRecommended: false,
	onlyLike: false,
	canLike: false,
	guestComment: null,
};

export default FeedPostStats;
